var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalfReviewStar = function SvgHalfReviewStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 30",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F2",
    d: "M31.08 12.48a1 1 0 0 0-.6-1.78l-10.32-.17L16.68.67a1 1 0 0 0-1.9 0l-3.47 9.86-10.33.17a1 1 0 0 0-.6 1.78l8.2 6.45-2.91 9.79a1 1 0 0 0 1.51 1.11l8.55-5.7 8.54 5.7a1 1 0 0 0 1.52-1.11l-2.91-9.79 8.2-6.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CB9731",
    d: "M14.79.67a1 1 0 0 1 .94-.67v24.12l-8.55 5.71a1 1 0 0 1-1.51-1.11l2.9-9.79-8.19-6.45a1 1 0 0 1 .6-1.78l10.33-.17L14.79.67Z"
  })));
};
export default SvgHalfReviewStar;